module.exports = __webpack_public_path__ + "static/img/p5.9fcc13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/p5.png
// module id = j9LO
// module chunks = 0 1